import { render, staticRenderFns } from "./DetailTableRentals.vue?vue&type=template&id=0235b12d&scoped=true&"
import script from "./DetailTableRentals.vue?vue&type=script&lang=js&"
export * from "./DetailTableRentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235b12d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
